/**
 * Taille des cibles hors texte courant (WCAG 2.2 § 2.5.8, FND-V050-076, FND-V050-162).
 *
 * Un lien isolé (liste d'étapes, « Membres et équipes », carte kanban) n'est pas un lien
 * « dans une phrase » : l'exception de 2.5.8 ne le couvre pas. Mesuré sur la pile v0.5.0 :
 * 15 à 17 px de haut. Plancher : 44 px au téléphone, 24 px à partir de 768 px.
 */
export const LIEN_CIBLE = 'inline-flex min-h-11 items-center underline underline-offset-2 md:min-h-6'

/**
 * Plancher de 24 px à TOUTES les largeurs, sans style de texte imposé : lien ou bouton-texte
 * d'une cellule de tableau, d'une ligne de liste dense ou d'une rangée d'actions (FND-V050-162 :
 * Graphe, Missions, Versions, Cockpit HITL, Vue programme… mesurés de 15 à 20 px de haut).
 * Les listes denses ne prennent pas les 44 px du téléphone : la ligne entière doublerait.
 */
export const CIBLE_24 = 'inline-flex min-h-6 items-center'

/** Lien isolé souligné d'une liste ou d'un tableau : plancher de 24 px à toutes les largeurs. */
export const LIEN_LISTE = `${CIBLE_24} underline underline-offset-2`

/**
 * Lien DANS une phrase (reste en ligne, souligné : WCAG 1.4.1 « link-in-text-block ») : le
 * rembourrage vertical d'un élément EN LIGNE agrandit la zone cliquable jusqu'à 24 px sans
 * déplacer la ligne de texte (texte-xs : 15 px de contenu + 2 × 6 px = 27 px).
 */
export const LIEN_EN_TEXTE = 'py-1.5 underline underline-offset-2'
